import { TransparentButton, Typography } from '@libs/components';
import styled from 'styled-components';

type TextToAccumulateProps = {
  isLink?: boolean;
};
export const TextToAccumulate = styled(Typography)<TextToAccumulateProps>`
  text-decoration: underline
    ${({ theme, isLink }) =>
      isLink ? theme.colors.interactive.brandColor : 'none'};
`;

export const CustomTransparentButton = styled(TransparentButton)`
  display: contents;
`;
